(() => {
  function qs(el, sel) { return el.querySelector(sel); }
  function create(el, cls) { const n = document.createElement(el); if (cls) n.className = cls; return n; }

  async function fetchBundleComponents({ shop, token, handle }) {
    const endpoint = `https://${shop}/api/2025-01/graphql.json`;
    const query = `query ProductBundleByHandle($handle: String!) {\n  product(handle: $handle) {\n    selectedOrFirstAvailableVariant {\n      ... on ProductVariant {\n        requiresComponents\n        components(first: 30) {\n          nodes {\n            quantity\n            productVariant {\n              id\n              title\n              image { url }\n              product { handle title }\n            }\n          }\n        }\n      }\n    }\n  }\n}`;
    const res = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token
      },
      body: JSON.stringify({ query, variables: { handle } })
    });
    if (!res.ok) throw new Error('Storefront API error');
    return res.json();
  }

  function renderList(container, nodes) {
    const bundleWrapper = container.closest('.product__bundle-wrapper');
    if (bundleWrapper) {
      bundleWrapper.classList.remove('hidden');
    }
    const colorScheme = container.getAttribute('data-color-scheme');
    container.innerHTML = '';
    const list = create('ul', 'bundle-components__list');
    nodes.forEach(({ quantity, productVariant }) => {
      const li = create('li', `bundle-components__item color-${colorScheme}`);
      const a = create('a', 'bundle-components__link');
      a.href = `/products/${productVariant.product.handle}`;
      const img = create('img', 'bundle-components__image');
      if (productVariant.image && productVariant.image.url) {
        img.src = productVariant.image.url;
        img.alt = productVariant.title;
        img.loading = 'lazy';
        img.width = 84; img.height = 84;
      }
      const info = create('div', 'bundle-components__info');
      const title = create('div', 'bundle-components__title');
      const title_head = create('div', 'bundle-components__title_head');
      const title_text = productVariant.title === 'Default Title'
        ? productVariant.product.title
        : `${productVariant.product.title}`;

      if(title_text.includes('|')){
        const titleArr = title_text.split("|");
        title.textContent = titleArr[1];
        title_head.textContent = titleArr[0];
      }else{
        title.textContent = title_text;
        title_head.textContent = '';
      }

      title.textContent = `(${quantity}) ${title.textContent}`;
      info.appendChild(title_head);
      info.appendChild(title);
      a.appendChild(img);
      a.appendChild(info);
      li.appendChild(a);
      list.appendChild(li);
    });
    container.appendChild(list);
  }

  async function init() {
    const container = document.getElementById('bundle-components');
    if (!container) return;
    const handle = container.getAttribute('data-product-handle');
    const token = container.getAttribute('data-sf-token');
    const shop = container.getAttribute('data-shop-domain') || window?.Shopify?.shop || window?.Shopify?.routes?.root?.replace(/^https?:\/\//, '')?.replace(/\/$/, '');
    if (!handle || !token || !shop) return;

    container.innerHTML = '<div class="bundle-components__loading">Loading bundle contents…</div>';
    try {
      const data = await fetchBundleComponents({ shop, token, handle });
      const variant = data?.data?.product?.selectedOrFirstAvailableVariant;
      const isBundle = !!variant?.requiresComponents;
      const nodes = variant?.components?.nodes || [];
      if (!isBundle || nodes.length === 0) {
        container.innerHTML = '';
        return;
      }
      renderList(container, nodes);
    } catch (e) {
      container.innerHTML = '';
      // Silently fail to avoid breaking PDP
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
